import React from 'react';

export const MailBoxSVG = () => (
    <svg
        width="108"
        height="104"
        viewBox="0 0 108 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="56" cy="52" r="52" fill="white" />
        <mask
            id="mask0_1"
            maskType=" alpha"
            maskUnits="userSpaceOnUse"
            x="3"
            y="0"
            width="105"
            height="104"
        >
            <circle cx="55.7783" cy="52" r="52" fill="white" />
        </mask>
        <g mask="url(#mask0_1)">
            <path
                d="M49 71H64V105.5C64 109.642 60.6421 113 56.5 113C52.3579 113 49 109.642 49 105.5V71Z"
                fill="#3D5580"
            />
            <path
                d="M58.9174 71H64V104.727C64 109.296 60.4183 113 56 113C58.2793 111.02 58.9174 109.296 58.9174 104.727V71Z"
                fill="#22385E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.6827 22H40.2676V71H59.1553H75.6827H93.3899V39.1173C93.3899 29.6637 85.7262 22 76.2726 22C76.0752 22 75.8785 22.0033 75.6827 22.01V22Z"
                fill="url(#paint0_mask)"
            />
            <path
                d="M11 66.1805C11 65.5285 11.5285 65 12.1805 65H58V68.639C58 69.9429 56.9429 71 55.639 71H13.361C12.0571 71 11 69.9429 11 68.639V66.1805Z"
                fill="#8898B5"
            />
            <path
                d="M24 39C24 29.6112 31.6112 22 41 22C50.3888 22 58 29.6112 58 39V65H24V39Z"
                fill="#50668C"
            />
            <path
                d="M13.6484 40.3522L32.1941 53.4001L50.7396 40.3522V62.349C50.7396 63.8122 49.5535 64.9983 48.0903 64.9983H16.2978C14.8346 64.9983 13.6484 63.8122 13.6484 62.349L13.6484 40.3522Z"
                fill="#C4CBD8"
            />
            <path
                d="M13.6484 40.3522L26.913 49.6846C29.134 51.2472 35.2407 55.5701 37.4527 57.1455C39.8529 58.8551 43.3488 61.345 48.4403 64.9713C48.2232 65.0103 47.9406 64.9983 47.4801 64.9983C47.0065 64.9973 46.0972 64.9983 45.5734 64.9983C44.3607 64.9983 23.72 64.9983 16.2881 64.9983C14.8249 64.9983 13.6484 63.8122 13.6484 62.349L13.6484 40.3522Z"
                fill="#E9ECF1"
            />
            <g filter="url(#svg-filter)">
                <path
                    d="M32.1934 40.0622L50.5694 40.0027C50.829 40.0019 50.9348 40.3361 50.7221 40.4848L32.1992 53.4302L13.6929 40.5072C13.4802 40.3587 13.5857 40.0246 13.8451 40.0251L32.1934 40.0622Z"
                    fill="white"
                />
            </g>
            <path
                opacity="0.6"
                d="M51.5861 38.8565C51.5861 32.7899 49.3906 26.7939 43.9737 23.8521C43.0466 23.3486 40.462 22.2808 37 22.5122C39.838 21.8178 41.8715 22.0217 42.2568 22.0479C51.0516 22.6448 58 29.9422 58 38.8565V65H51.5861V38.8565Z"
                fill="#2A4473"
            />
        </g>
        <path
            d="M66.5703 8.29579C66.5703 6.90688 67.6962 5.78094 69.0852 5.78094H70.4823V40.9887H66.5703V8.29579Z"
            fill="#2A4473"
        />
        <path
            d="M70.4824 5.78094H81.0541C83.1374 5.78094 84.8263 7.46984 84.8263 9.55321V13.7446C84.8263 15.828 83.1374 17.5169 81.0541 17.5169H70.4824V5.78094Z"
            fill="#982EA9"
        />
        <circle cx="68.4102" cy="41.5708" r="3.14355" fill="#2A4473" />
        <rect
            x="26.0703"
            y="77.3889"
            width="3.00828"
            height="3.00828"
            transform="rotate(-54.5 26.0703 77.3889)"
            fill="#982EA9"
        />
        <rect
            x="6.0166"
            y="21.4521"
            width="4.01104"
            height="4.01104"
            transform="rotate(-24.5 6.0166 21.4521)"
            fill="#E3C5E7"
        />
        <rect
            x="6.0166"
            y="21.4521"
            width="4.01104"
            height="4.01104"
            transform="rotate(-24.5 6.0166 21.4521)"
            fill="#8155DB"
        />
        <rect
            x="10.0264"
            y="85.6288"
            width="4.01104"
            height="4.01104"
            transform="rotate(-24.5 10.0264 85.6288)"
            fill="#D09FD8"
        />
        <rect
            x="51.1406"
            y="16.8851"
            width="3.50966"
            height="3.50966"
            transform="rotate(-62.5 51.1406 16.8851)"
            fill="#D09FD8"
        />
        <rect
            y="73.9365"
            width="3.00828"
            height="3.00828"
            transform="rotate(-89 0 73.9365)"
            fill="#8155DB"
        />
        <path
            d="M4.03496 50.9051C2.68853 49.7405 0.650173 46.5198 3.26819 42.9541"
            stroke="#982EA9"
            strokeWidth="1.15645"
            strokeLinecap="round"
        />
        <path
            d="M24.4025 13.7712C25.9616 14.6305 28.6251 17.3569 26.8056 21.389"
            stroke="#BD79C8"
            strokeWidth="1.15645"
            strokeLinecap="round"
        />
        <rect
            x="39.0215"
            y="8.7254"
            width="2.78096"
            height="2.78096"
            transform="rotate(-67 39.0215 8.7254)"
            fill="#AB54B9"
        />
        <defs>
            <filter
                id="svg-filter"
                x="10.8037"
                y="38.615"
                width="42.8077"
                height="18.9783"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.38772" />
                <feGaussianBlur stdDeviation="1.38772" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_284_36478"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_284_36478"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_mask"
                x1="66.8287"
                y1="22"
                x2="66.8287"
                y2="71"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9DA9BF" stopOpacity="0.42" />
                <stop offset="1" stopColor="#8797B4" />
            </linearGradient>
        </defs>
    </svg>
);

export const MailBoxMobileSVG = () => (
    <svg
        width="83"
        height="80"
        viewBox="0 0 83 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="43" cy="40" r="40" fill="white" />
        <mask
            id="mask0_small"
            maskType="alpha"
            maskUnits="userSpaceOnUse"
            x="3"
            y="0"
            width="80"
            height="80"
        >
            <circle cx="43" cy="40" r="40" fill="white" />
        </mask>
        <g mask="url(#mask0_small)">
            <path
                d="M37.7861 54.5648H49.3246V81.0734C49.3246 84.2596 46.7416 86.8426 43.5554 86.8426C40.3691 86.8426 37.7861 84.2596 37.7861 81.0734V54.5648Z"
                fill="#3D5580"
            />
            <path
                d="M45.415 54.5648H49.3247V80.4848C49.3247 83.9961 46.5696 86.8426 43.1709 86.8426C44.9242 85.3211 45.415 83.9961 45.415 80.4849V54.5648Z"
                fill="#22385E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.598 54.6154H31.0688V16.9231H58.3112V16.9308C58.4619 16.9257 58.6133 16.9231 58.7652 16.9231C66.0372 16.9231 71.9324 22.8182 71.9324 30.0903V54.6154H58.3112H45.598Z"
                fill="url(#paint0_linear_small)"
            />
            <path
                d="M8.55566 50.861C8.55566 50.3599 8.96185 49.9537 9.4629 49.9537H44.7095V52.7504C44.7095 53.7525 43.8971 54.5648 42.895 54.5648H10.3701C9.36803 54.5648 8.55566 53.7525 8.55566 52.7504V50.861Z"
                fill="#8898B5"
            />
            <path
                d="M18.5552 30C18.5552 22.7778 24.4099 16.9231 31.6321 16.9231C38.8543 16.9231 44.709 22.7778 44.709 30V50H18.5552V30Z"
                fill="#50668C"
            />
            <path
                d="M10.5928 31.0402L24.8586 41.0771L39.1245 31.0402V47.9627C39.1245 49.0872 38.2129 49.9988 37.0884 49.9988H12.6289C11.5044 49.9988 10.5928 49.0872 10.5928 47.9627L10.5928 31.0402Z"
                fill="#C4CBD8"
            />
            <path
                d="M10.5928 31.0402L20.8 38.2216C22.5069 39.4225 27.1999 42.7446 28.8998 43.9553C30.7463 45.2705 33.4364 47.1865 37.3557 49.978C37.1887 50.0079 36.9714 49.9988 36.6171 49.9988C36.2528 49.9979 35.5534 49.9988 35.1504 49.9988C34.2175 49.9988 18.3365 49.9988 12.6213 49.9988C11.4968 49.9988 10.5928 49.0872 10.5928 47.9627L10.5928 31.0402Z"
                fill="#E9ECF1"
            />
            <g filter="url(#filter0_d_small)">
                <path
                    d="M24.8579 30.817L38.9939 30.7713C39.1934 30.7707 39.2747 31.0276 39.1112 31.1418L24.8624 41.1001L10.6263 31.1591C10.4628 31.0449 10.5439 30.7881 10.7433 30.7885L24.8579 30.817Z"
                    fill="white"
                />
            </g>
            <path
                opacity="0.6"
                d="M39.7753 29.8896C39.7753 25.2231 38.0864 20.6107 33.9196 18.3478C33.2064 17.9605 31.2183 17.1391 28.5552 17.3171C30.7382 16.7829 32.3025 16.9398 32.5989 16.9599C39.3641 17.4191 44.709 23.0324 44.709 29.8896V50H39.7753V29.8896Z"
                fill="#2A4473"
            />
        </g>
        <path
            d="M51.1606 6.37545C51.1606 5.30805 52.0259 4.44275 53.0933 4.44275H54.1671V31.5006H51.1606V6.37545Z"
            fill="#2A4473"
        />
        <path
            d="M54.1665 4.44275H62.291C63.8921 4.44275 65.1901 5.7407 65.1901 7.3418V10.563C65.1901 12.1641 63.8921 13.462 62.291 13.462H54.1665V4.44275Z"
            fill="#982EA9"
        />
        <circle cx="52.5741" cy="31.9479" r="2.41588" fill="#2A4473" />
        <rect
            x="20.0356"
            y="59.4748"
            width="2.31192"
            height="2.31192"
            transform="rotate(-54.5 20.0356 59.4748)"
            fill="#982EA9"
        />
        <rect
            x="4.62354"
            y="16.4864"
            width="3.08256"
            height="3.08256"
            transform="rotate(-24.5 4.62354 16.4864)"
            fill="#E3C5E7"
        />
        <rect
            x="4.62354"
            y="16.4864"
            width="3.08256"
            height="3.08256"
            transform="rotate(-24.5 4.62354 16.4864)"
            fill="#8155DB"
        />
        <rect
            x="7.70508"
            y="65.8074"
            width="3.08256"
            height="3.08256"
            transform="rotate(-24.5 7.70508 65.8074)"
            fill="#D09FD8"
        />
        <rect
            x="39.3027"
            y="12.9765"
            width="2.69724"
            height="2.69724"
            transform="rotate(-62.5 39.3027 12.9765)"
            fill="#D09FD8"
        />
        <rect
            y="56.8216"
            width="2.31192"
            height="2.31192"
            transform="rotate(-89 0 56.8216)"
            fill="#8155DB"
        />
        <path
            d="M3.1007 39.1215C2.06594 38.2265 0.499426 35.7513 2.51142 33.011"
            stroke="#982EA9"
            strokeWidth="0.88875"
            strokeLinecap="round"
        />
        <path
            d="M18.7539 10.5835C19.9521 11.2438 21.999 13.3392 20.6007 16.4379"
            stroke="#BD79C8"
            strokeWidth="0.88875"
            strokeLinecap="round"
        />
        <rect
            x="29.9888"
            y="6.70563"
            width="2.13722"
            height="2.13722"
            transform="rotate(-67 29.9888 6.70563)"
            fill="#AB54B9"
        />
        <defs>
            <filter
                id="filter0_d_small"
                x="8.40609"
                y="29.7048"
                width="32.9256"
                height="14.5947"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.06649" />
                <feGaussianBlur stdDeviation="1.06649" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_small"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_small"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_small"
                x1="51.5006"
                y1="16.9231"
                x2="51.5006"
                y2="54.6154"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#9DA9BF" stopOpacity="0.42" />
                <stop offset="1" stopColor="#8797B4" />
            </linearGradient>
        </defs>
    </svg>
);
